<template>
  <div class="stack stack--small">
    <div
      v-if="recentContainers && status !== 'listing-structure' && status !== 'structure-listed'"
      class="stack stack--small"
    >
      <SelectionGroup
        v-model="selectedContainer"
        type="radio"
        name="containers"
        :options="recentContainersSelectionOptions"
      />
    </div>
    <div class="stack stack--small">
      <a
        v-if="status !== 'listing-structure' && status !== 'structure-listed'"
        href="/"
        @click.prevent="listContainers"
      >
        Načíst další šanony
      </a>
      <template v-if="status === 'listing-structure'">
        Načítám strukturu…
      </template>
      <template v-else-if="status === 'structure-listed'">
        <SelectionGroup
          v-model="selectedCabinet"
          type="select"
          name="cabinets"
          label="Skříň"
          :options="cabinetsSelectionOptions"
        />
        <SelectionGroup
          v-if="selectedCabinet"
          v-model="selectedShelf"
          type="select"
          name="shelves"
          label="Polička"
          :options="shelvesSelectionOptions"
        />
        <SelectionGroup
          v-if="selectedShelf"
          v-model="selectedContainer"
          type="select"
          name="containers"
          label="Šanon"
          :options="containersSelectionOptions"
        />
      </template>
      <template v-else-if="status === 'something-wrong'">
        Něco se pokazilo, ozvěte se nám prosím
      </template>
    </div>
  </div>
</template>

<script>
import SelectionGroup from '@/components/SelectionGroup';

import DocumentManager from '@/mixins/DocumentManager';

export default {
  name: 'ContainersList',
  components: {
    SelectionGroup,
  },
  mixins: [
    DocumentManager,
  ],
  props: {
    token: {
      type: String,
    },
    roomID: {
      type: String,
    },
    name: {
      type: String,
    },
  },
  data() {
    return {
      status: null,
      containers: null,
      selectedCabinet: '',
      selectedShelf: '',
      selectedContainer: '',
      recentContainers: null,
    };
  },
  computed: {
    cabinetsSelectionOptions() {
      const options = this.containers.map((container) => ({
        id: container.shelf.cabinet.id,
        label: container.shelf.cabinet.label,
      }));
      return options.reduce((uniqueOptions, reducer) => {
        if (!uniqueOptions.some((item) => item.id === reducer.id)) uniqueOptions.push(reducer);
        return uniqueOptions;
      }, []);
    },
    shelvesSelectionOptions() {
      const options = this.containers.map((container) => ({
        id: container.shelf.id,
        label: container.shelf.label,
        cabinet: container.shelf.cabinet.id,
      }));
      const filteredOptions = options.filter((shelf) => (shelf.cabinet === this.selectedCabinet));
      return filteredOptions.reduce((uniqueOptions, reducer) => {
        if (!uniqueOptions.some((item) => item.id === reducer.id)) uniqueOptions.push(reducer);
        return uniqueOptions;
      }, []);
    },
    containersSelectionOptions() {
      const options = this.containers.map((container) => ({
        id: container.id,
        label: container.label || 'Odkladač',
        shelf: container.shelf.id,
      }));
      return options.filter((container) => (container.shelf === this.selectedShelf));
    },
    recentContainersSelectionOptions() {
      return this.recentContainers.map((container) => ({
        id: container.id,
        label: container.label || 'Odkladač',
        labelSecondary: `← ${container.shelf.label} ←  ${container.shelf.cabinet.label}`,
      }));
    },
  },
  watch: {
    status() {
      this.$emit('status-change', { status: this.status, data: this.$data });
      this.selectedCabinet = '';
      this.selectedShelf = '';
      this.selectedContainer = '';
    },
    selectedCabinet() {
      this.selectedShelf = '';
      this.selectedContainer = '';
    },
    selectedShelf() { this.selectedContainer = ''; },
    selectedContainer() {
      this.updateRecentContainers();
      this.onSelectedChange();
    },
    recentContainers() { this.updateLocalRecentContainers(); },
  },
  methods: {
    async listContainers() {
      try {
        this.status = 'listing-structure';
        const containers = await this.$_DocumentManager_listAllExpandedContainers({
          token: this.token,
        });
        this.containers = containers;
        this.status = 'structure-listed';
      } catch (error) {
        this.status = 'something-wrong';
        throw error;
      }
    },
    onSelectedChange() {
      const containers = this.containers || this.recentContainers;
      if (this.selectedContainer) {
        const filteredContainers = containers
          .filter((container) => (container.id === this.selectedContainer));
        this.$emit('container-change', {
          id: filteredContainers[0].id,
          type: filteredContainers[0].type,
          label: filteredContainers[0].label,
        });
      } else {
        this.$emit('container-change');
      }
    },
    updateRecentContainers() {
      if (this.selectedContainer && this.containers) {
        const selectedContainer = this.containers
          .filter((container) => (container.id === this.selectedContainer))[0];
        let array = Array.isArray(this.recentContainers) ? this.recentContainers.reverse() : [];
        if (array.filter((container) => (container.id === this.selectedContainer)).length > 0) {
          array = array.filter((container) => (container.id !== this.selectedContainer));
        } else if (array.length >= 5) {
          array.shift();
        }
        array.push(selectedContainer);
        this.recentContainers = array.reverse();
      }
    },
    retrieveLocalRecentContainers() {
      this.status = 'retrieving-recent-containers';
      if (localStorage.recentContainers) {
        try {
          this.recentContainers = JSON.parse(localStorage.recentContainers)[this.roomID][this.name];
        } catch {
          this.recentContainers = null;
        }
      }
      if (this.recentContainers) {
        this.status = 'retrieved-recent-containers';
      }
    },
    updateLocalRecentContainers() {
      let recentContainers;
      if (localStorage.recentContainers) {
        recentContainers = JSON.parse(localStorage.recentContainers);
        recentContainers[this.roomID] = {
          ...recentContainers[this.roomID],
          [this.name]: this.recentContainers,
        };
      } else {
        recentContainers = { [this.roomID]: { [this.name]: this.recentContainers } };
      }
      localStorage.recentContainers = JSON.stringify(recentContainers);
    },
  },
  mounted() {
    this.retrieveLocalRecentContainers();
    if (!this.recentContainers) {
      this.listContainers();
    }
  },
  beforeDestroy() {
    this.containers = [];
    this.selectedCabinet = '';
    this.selectedShelf = '';
    this.selectedContainer = '';
    this.onSelectedChange();
  },
};
</script>
